import { z } from "zod";

export const smtpSettingsSchema = z.object({
  smtpHost: z.string().min(1, "SMTP Host is required"),
  smtpPort: z
    .string()
    .min(1, "SMTP Port is required")
    .regex(/^\d+$/, "Must be a valid port number"),
  smtpUsername: z.string().min(1, "Username is required"),
  smtpPassword: z.string(),
  smtpFromEmail: z
    .string()
    .min(1, "From Email is required")
    .email("Must be a valid email"),
  smtpFromName: z.string().min(1, "From Name is required"),
  smtpUseSsl: z.boolean(),
});

export type SmtpSettingsFormData = z.infer<typeof smtpSettingsSchema>;

export const sendTestEmailSchema = z.object({
  email: z.string().min(1, "Email is required").email("Must be a valid email"),
});

export type SendTestEmailFormData = z.infer<typeof sendTestEmailSchema>;
